<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_viii"><span class="bold">List of illustrations</span></a></h2><a id="page_viii">
<p class="hang_s1">An Alouette helicopter arriving at a landmine scene; Nyamapanda, 1976. Note the Internal Affairs Lee Enfield .303 in the foreground. (Ron Rink)</p>
<p class="hang_s1">Paddy Allen at Mukumbura, 1975. (Author’s collection)</p>
<p class="hang_s1">An India Troop (red and blue) lanyard and Support Unit shoulder flash.</p>
<p class="hang_s1">India Troop lads at Wedza TTL, 1977. (Kiaran Allen)</p>
<p class="hang_s1">Kiaran Allen and a troop sergeant at Diti TTL, 1977. (Kiaran Allen)</p>
<p class="hang_s1">The author at Diti TTL, 1977; the Nulli Hills are in the background. Note the starlight scope hanging off the neck. (Kiaran Allen)</p>
<p class="hang_s1">A burnt-out store; Chibi TTL, 1977.</p>
<p class="hang_s1">The Paddy Allen memorial; Warren Hills, Salisbury.</p>
<p class="hang_s1">The Wilson Banda memorial; Warren Hills, Salisbury.</p>
<p class="hang_s1">Ron Rink sitting on a keep wall; Nyamapanda, 1976. (Ron Rink)</p>
<p class="hang_s1">Mick Busby, Billy Pring and the author at Plumtree, 1978. (Ray Hughes)</p>
<p class="hang_s1">Ray Hughes receiving his wings, 1980. (Dave and Eileen Hughes)</p>
<p class="hang_s1">The Police Commissioner’s letter.</p>
<p class="hang_s1">Medal parade, 1978; the author receives the PCG wearing a hat lent to Joan Stapa by the Honourable P.K. van der Byl.</p>
<p class="hang_s1">Phil Smith: the epitome of the warrior. (Fiona Smith)</p>
<p class="hang_s1">Skip in Rushinga with a UANC detachment, 1979. (Skip Dolega)</p>
<p class="hang_s1">The author in plaster after the leg wound, 1979.</p>
<p class="hang_s1">The Shangaan Army lads lining up for the photo, 1979.</p>
<p class="hang_s1">Some captured weapons and ammunition by the Shangaans, 1979.</p>
<p class="hang_s1">The author working in farm security in the Marandellas District during the 1980 elections.</p>
<p class="hang_s1">Farm workers ready to vote with Colin and Jennifer, 1980.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Illustrations.vue?5a056aba